(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-knc-product]').forEach((root) => {
      if (root.dataset.kncInitialized) return;
      root.dataset.kncInitialized = 'true';
      const own = (selector) => Array.from(root.querySelectorAll(selector)).filter(el => el.closest('[data-knc-product]') === root);
      const source = own('[data-knc-json]')[0];
      if (!source) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch (_) { return; }
      const variants = data.variants || [];
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(value / 100);
      const update = (id) => {
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        own('input[name="id"]').forEach(input => { input.value = variant.id; });
        own('[data-knc-price]').forEach(el => { el.textContent = format(variant.price); });
        own('[data-knc-compare]').forEach(el => { el.textContent = variant.compare_at_price > variant.price ? format(variant.compare_at_price) : ''; });
        own('[data-knc-add]').forEach(button => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldLabel;
        });
        if (variant.featured_image && variant.featured_image.src) own('[data-knc-main-image]').forEach(img => { img.src = variant.featured_image.src; img.removeAttribute('srcset'); });
      };
      own('[data-knc-variant]').forEach(select => select.addEventListener('change', () => update(select.value)));
      own('[data-knc-image]').forEach(button => button.addEventListener('click', () => {
        own('[data-knc-main-image]').forEach(img => { img.src = button.dataset.kncImage; img.removeAttribute('srcset'); });
        own('[data-knc-image]').forEach(el => el.setAttribute('aria-pressed', el === button ? 'true' : 'false'));
      }));
      const initial = own('[data-knc-variant]')[0] || own('input[name="id"]')[0];
      if (initial) update(initial.value);
    });
    scope.querySelectorAll('[data-knc-slider]').forEach(root => {
      if (root.dataset.kncInitialized) return;
      root.dataset.kncInitialized='true';
      const slides = Array.from(root.querySelectorAll('.knc-sld-item'));
      if (!slides.length) return;
      let index=0;
      const change = step => {
        index=(index+step+slides.length)%slides.length;
        slides.forEach((slide,i) => {slide.classList.toggle('knc-sld-active',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});
      };
      root.querySelectorAll('.knc-sld-left,.knc-sld-right').forEach(control => {
        control.setAttribute('role','button');control.setAttribute('tabindex','0');
        const step=control.classList.contains('knc-sld-left')?-1:1;
        control.setAttribute('aria-label',step<0?window.KensuiCopy("b5f29d10f9828ee4c8","Previous slide",[]):window.KensuiCopy("c4151bfa2f0056910f","Next slide",[]));
        control.addEventListener('click',()=>change(step));
        control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();change(step);}});
      });
      change(0);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

